"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>utils_otpService
});
const account_less_auth_sdk_namespaceObject = require("@pcln/account-less-auth-sdk");
const index_js_namespaceObject = require("../constants/index.js");
const getSdk = ({ deliveryType, url })=>{
    switch(deliveryType){
        case index_js_namespaceObject.otpDeliveryMechanisms.SMS:
            return new account_less_auth_sdk_namespaceObject.SmsOtp(url);
        case index_js_namespaceObject.otpDeliveryMechanisms.SMS_PHONE:
            return new account_less_auth_sdk_namespaceObject.SmsPhoneOtp(url);
        case index_js_namespaceObject.otpDeliveryMechanisms.EMAIL:
            return new account_less_auth_sdk_namespaceObject.EmailOtp(url);
    }
};
const otpService = ({ deliveryType })=>{
    const url = 'account-less-auth';
    const accountLessSdk = getSdk({
        deliveryType,
        url
    });
    if (!accountLessSdk) throw new Error('AccountLess Sdk needs to be initialized');
    let verifyFn = null;
    return {
        createChallenge: async ({ scope, requestFrom, countryCode, phoneNumber, email, requestHeaders })=>{
            try {
                verifyFn = null;
                const accountLessSdkPromise = accountLessSdk.withScope(scope).withRequestFrom(requestFrom).withPhoneNumber(countryCode, phoneNumber);
                if (deliveryType !== index_js_namespaceObject.otpDeliveryMechanisms.SMS_PHONE) accountLessSdkPromise.withEmail(email);
                const challenge = await accountLessSdkPromise.build().createChallenge({
                    headers: requestHeaders
                });
                if (challenge.success) {
                    verifyFn = challenge.verify;
                    return challenge.success;
                }
                throw new Error('Unable to create a challenge');
            } catch (_e) {
                throw new Error('Account less sdk api error');
            }
        },
        verify: async (otpCode)=>{
            if (verifyFn) try {
                const verifyResult = await verifyFn(otpCode);
                return {
                    success: verifyResult.success,
                    token: verifyResult.success ? verifyResult.token : ''
                };
            } catch (_e) {
                throw new Error('Otp verificaton api failed');
            }
            throw new Error('Verification function is required');
        }
    };
};
const utils_otpService = otpService;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
